module.exports = __webpack_public_path__ + "img/blockstory_neg.18891e1f.png";